import withProps from "recompose/withProps";


export default withProps({
  sx:{


  }
});
